module.exports = __webpack_public_path__ + "moraisprodutos.jpg?af65f208304697a68a9486b8e7491373";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/moraisprodutos.jpg
// module id = 139
// module chunks = 0